import { TooltipExtension } from "Grids/Extension";
import { BaseLayout } from "./BaseLayout";
import { AppContext, DMSMenu } from "Core";

export class DialogMenuLayout extends BaseLayout {
    private static layout = require("./Templates/MenuDialog.html").default;

    private tooltipExtension: TooltipExtension;

    apply(): void {
        this.setMenuLayout(DialogMenuLayout.layout);
        $("body").addClass("dms-no-sidemenu");

        DMSMenu.initialize(AppContext.current.serviceProvider.Menu, AppContext.current.serviceProvider.TextBlock);

        if (this.tooltipExtension) {
            this.tooltipExtension.dispose();
            this.tooltipExtension = null;
        }
        this.tooltipExtension = new TooltipExtension();
        this.tooltipExtension.initialize($(".dms-sidemenu"));
    }
}
